'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _publicToolbar = require('../../public-toolbar');

var _publicToolbar2 = _interopRequireDefault(_publicToolbar);

var _contact = require('../../contact');

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeachersController = function () {
  function TeachersController($document, config, fContactService) {
    _classCallCheck(this, TeachersController);

    this.config = config;
    this._svc = {
      $document: $document, fContactService: fContactService
    };

    var scriptUrl = 'https://ifeis.ladesk.com/scripts/track.js';
    var node = document.createElement('script');
    node.src = scriptUrl;
    node.id = 'la_x2s6df8e';
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    node.onload = function (e) {
      LiveAgent.createForm('6f3cfe35', document.getElementById("liveAgentWidgetForAddTeacherDiv"));
    };
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  _createClass(TeachersController, [{
    key: 'sendMessage',
    value: function sendMessage(msg) {
      var _this = this;

      this.error = "";
      this.sending = true;
      this.success = "";
      this._svc.fContactService.email(msg).then(function () {
        _this.sending = false;
        _this.success = 'Success! Email sent successfully!';
        _this.msg = {};
      }, function (err) {
        _this.sending = false;
        _this.error = 'Error! ' + err.data.errors[0].title;
      });
    }
  }]);

  return TeachersController;
}();

exports.default = angular.module('ifeis.routes.teachers', ['ui.router', 'ifeis.public-toolbar', 'ifeis.contact', 'duScroll']).config(function ($stateProvider) {
  $stateProvider.state('teachers', {
    url: '/teachers',
    controller: 'TeachersController',
    controllerAs: 'ctrl',
    template: require('./tpl.html')
  });
}).controller('TeachersController', TeachersController);


//////////////////
// WEBPACK FOOTER
// ./routes/teachers/index.js
// module id = 604
// module chunks = 0